import ArchiveIcon from '@mui/icons-material/Archive';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useContextMenuContext } from 'shared/mui/ContextMenu/context/contextMenuContext';
import {
  ContextMenuButton,
  ContextMenuButtonProps,
} from 'shared/mui/ContextMenu/ContextMenuButton/ContextMenuButton';

export type ContextMenuUnarchiveButtonProps = Omit<
  ContextMenuButtonProps,
  'icon' | 'label' | 'onClick'
> & {
  onClick: NonNullable<ContextMenuButtonProps['onClick']>;
};

export const ContextMenuUnarchiveButton: React.FC<ContextMenuUnarchiveButtonProps> = ({
  onClick,
  ...restProps
}) => {
  const translate = useTypedTranslate();

  const { onCloseMenu } = useContextMenuContext();
  const handleClick = () => {
    onClick();
    onCloseMenu();
  };

  return (
    <ContextMenuButton
      icon={<ArchiveIcon fontSize="small" sx={{ marginTop: '1px', transform: 'rotate(180deg)' }} />}
      label={translate('app.buttons.unarchive')}
      {...restProps}
      onClick={handleClick}
    />
  );
};
